import { Valence } from '@upright/common/model/types';
import { KeyTakeawayConnector } from './connector/key-takeaway-connector';
import { KeyTakeawayInfoBox } from './info-box/key-takeaway-box';

export function KeyTakeawayConnectors() {
  return (
    <>
      <KeyTakeawayConnector valence={Valence.NEGATIVE} />
      <KeyTakeawayConnector valence={Valence.POSITIVE} />
    </>
  );
}

export function KeyTakeawayInfoBoxes() {
  return (
    <>
      <KeyTakeawayInfoBox valence={Valence.NEGATIVE} />
      <KeyTakeawayInfoBox valence={Valence.POSITIVE} />
    </>
  );
}
